import { render, staticRenderFns } from "./StructureUserSelector.vue?vue&type=template&id=5815cb4e&scoped=true"
import script from "./StructureUserSelector.vue?vue&type=script&lang=js"
export * from "./StructureUserSelector.vue?vue&type=script&lang=js"
import style0 from "./StructureUserSelector.vue?vue&type=style&index=0&id=5815cb4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5815cb4e",
  null
  
)

export default component.exports